<template>
  <div class="container">
    <top num="4"></top>
    <div class="banner">
      <img src="static/img/banner05.png" alt="" />
      <div>
        <p class="titlebanner">加入我们一起奔跑吧</p>
        <p class="descbanner">
          在这里，每个人都乐于积极创新，为做出美好的事情而努力
        </p>
      </div>
    </div>
    <div class="main">
      <table></table>
      <p class="title">工作环境</p>
      <div class="content" id="content01">
        <div class="flex">
          <div>
            <img src="static/img/pic13.png" alt="" />
            <p class="subtitle">舒适的办公环境</p>
            <p class="info">
              我们为地员工打造了舒适、创新，体现文化特色的办公环境。象征着互联网将各个角落互相连通，是一家专注连接人与人、人和服务、以及未来人和设备的互联网高科技企业。
            </p>
          </div>
          <div>
            <img src="static/img/pic14.png" alt="" />
            <p class="subtitle">多元的企业文化</p>
            <p class="info">
              我们为地员工打造了舒适、创新，体现文化特色的办公环境。象征着互联网将各个角落互相连通，是一家专注连接人与人、人和服务、以及未来人和设备的互联网高科技企业。
            </p>
          </div>
        </div>
      </div>
    </div>
    <div class="main" style="background: rgb(245, 247, 247)">
      <table></table>
      <p class="title">团建活动</p>
      <div class="content" id="content02">
        <div class="flex">
          <div class="topic">
            <img src="static/img/15.png" alt="" />
            <img src="static/img/pic15.png" class="bg" alt="" />
            <p>周边旅行</p>
          </div>
          <div class="topic">
            <img src="static/img/16.png" alt="" />
            <img src="static/img/pic15.png" class="bg" alt="" />
            <p>团队聚餐</p>
          </div>
          <div class="topic">
            <img src="static/img/17.png" alt="" />
            <img src="static/img/pic15.png" class="bg" alt="" />
            <p>文体协会</p>
          </div>
        </div>
        <div class="flex">
          <div class="topic">
            <img src="static/img/18.png" alt="" />
            <img src="static/img/pic15.png" class="bg" alt="" />
            <p>户外活动</p>
          </div>
          <div class="topic">
            <img src="static/img/19.png" style="width: 4.1875rem" alt="" />
            <img
              src="static/img/pic15.png"
              style="width: 4.1875rem"
              class="bg"
              alt=""
            />
            <p>公司年会</p>
          </div>
        </div>
      </div>
    </div>
    <div class="main">
      <table></table>
      <p class="title">联系方式</p>
      <div class="content">
        <p
          style="
            font-size: 0.09375rem;
            text-align: center;
            margin-top: 0.510416rem;
            margin-bottom: 0.75rem;
          "
        >
          HR@prestamoo.mx
        </p>
        <img src="static/img/pic17.png" style="width: 100%" alt="" />
      </div>
    </div>
    <bottom></bottom>
  </div>
</template>
<script>
import bottom from "./bottom.vue";
import Top from "./top.vue";
export default {
  components: { Top, bottom },
  name: "joinus",
  data() {
    return {};
  },
};
</script>
<style scoped>
img {
  display: block;
}
.banner img {
  width: 100%;
}
.banner {
  position: relative;
  color: white;
}
.banner > div {
  position: absolute;
  top: 0.7rem;
  left: 1.66rem;
}
.banner .titlebanner {
  font-size: 0.3125rem;
  font-weight: bold;
}
.banner .descbanner {
  font-size: 0.145833rem;
  margin-top: 0.2rem;
}
.main {
  padding-bottom: 0.65625rem;
}
.title {
  font-size: 0.208333rem;
  text-align: center;
  margin-top: 0.552083rem;
  margin-bottom: 0.6875rem;
}
.content {
  width: 6.354167rem;
  margin: 0 auto;
}
.flex {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
#content01 .flex img {
  width: 3.072917rem;
  margin-bottom: 0.25rem;
}
#content01 .flex > div {
  width: 3.072917rem;
}
#content01 .flex .subtitle {
  font-size: 0.135417rem;
  margin-bottom: 0.15625rem;
  font-weight: 500;
}
#content01 .info {
  font-size: 0.104167rem;
}
#content02 .flex img {
  width: 2.03125rem;
  margin-bottom: 0.104167rem;
}
#content02 .topic {
  position: relative;
}
#content02 .topic p {
  position: absolute;
  top: 0.15rem;
  left: 0.15rem;
  color: white;
  font-size: 0.145833rem;
  font-weight: 500;
}
#content02 .topic .bg {
  position: absolute;
  top: 0;
  left: 0;
}
</style>


// WEBPACK FOOTER //
// src/components/joinus.vue